export default __webpack_public_path__ + "static/media/logo-xl-480w.38f97837.webp";